import { CompanyInfoModel, EmployerInfoModel, SocialNetworkModel } from '.'
import { isUnknownObject } from '~/shared/utils/guards'
import { BaseModel, convertToArrayModels, fillOwnProperties, registerModel } from '~/shared/model'
import roles from '~/shared/const/roles'
import type { UnknownObject } from '~/shared/interfaces'
import type { RoleId } from '~/types/user/user-roles'
import type { Integrations } from '~/types/user/integrations'

export default class UserModel extends BaseModel {
  static override constructorName = 'UserModel'

  public id: string = ''
  public idShort: string = ''
  public name: string = ''
  public firstname: string = ''
  public lastname: string = ''
  public middlename: string = ''
  public email: string = ''
  public phone: string = ''
  public dateOfBirth: string = ''
  public isHaveDigitalProfile = false
  public isHaveResume = false
  public isSimpleFeedbacksEnabled: boolean = false
  public idForIntegrations: string = ''
  public employer: EmployerInfoModel = new EmployerInfoModel({})
  public attributes: UnknownObject = {}
  public roles: Set<RoleId> = new Set()
  public allowedRoutes: Array<RegExp> = []
  public socialNetworks: Array<SocialNetworkModel> = []
  public integrations: Array<Integrations> = []
  public 'sf_company': CompanyInfoModel = new CompanyInfoModel({})
  public vacancyCompanies: string[] = []

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['roles'])

      if (isUnknownObject(data.profile) && isUnknownObject(data.profile.data)) {
        const profileData = data.profile.data

        if (isUnknownObject(profileData.additional_info)) {
          fillOwnProperties(this, profileData.additional_info)
          this.dateOfBirth = String(profileData.additional_info.dob)
        }

        if (isUnknownObject(profileData.sf) && isUnknownObject(profileData.sf.attributes)) {
          this.attributes = profileData.sf.attributes
        }
      }

      this.socialNetworks = convertToArrayModels(data.users_socials, SocialNetworkModel)

      if (Array.isArray(data.users_roles)) {
        data.users_roles.forEach((r: RoleId) => {
          if (roles[r] !== undefined) {
            this.roles.add(r)
            this.allowedRoutes = this.allowedRoutes.concat(roles[r].allowedRoutes)
          }
        })
      }
    }
  }
}

registerModel(UserModel)
